import createResource from './createResource';
import { Procedure } from './types';

const proceduresResource = createResource<Procedure>({
  key: 'procedures',
  url: '/procedures',
  });

export default proceduresResource;
